import type { SlideImage } from "yet-another-react-lightbox";
export function Gallery2017(){

const slides: SlideImage[] = [
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_001.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_001.jpg",
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_002.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_002.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_003.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_003.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_004.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_004.jpg",
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_005.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_005.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_006.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_006.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_007.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_007.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_008.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_008.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_009.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_009.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_010.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_010.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_011.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_011.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_012.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_012.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_013.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_013.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_014.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_014.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_015.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_015.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_016.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_016.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_017.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_017.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_018.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_018.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_019.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_019.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_020.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_020.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_021.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_021.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_022.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_022.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_023.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_023.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_024.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_024.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_025.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_025.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_026.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_026.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_027.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_027.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_028.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_028.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_029.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_029.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_030.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_030.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_031.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_031.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_032.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_032.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_033.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_033.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_034.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_034.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_035.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_035.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_036.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_036.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_037.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_037.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_038.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_038.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_039.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_039.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_040.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_040.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_041.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_041.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_042.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_042.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_043.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_043.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_044.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_044.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_045.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_045.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_046.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_046.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_047.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_047.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_048.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_048.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_049.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_049.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_050.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_050.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_051.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_051.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_052.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_052.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_053.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_053.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_054.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_054.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_055.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_055.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_056.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_056.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_057.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_057.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_058.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_058.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_059.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_059.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_060.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_060.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_061.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_061.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_062.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_062.jpg"
	    },
	    {
	      "src": "https://jamhaw.com/images/gallery/Gallery2017/SML_063.jpg",
	      "alt": "https://jamhaw.com/images/gallery/Gallery2017/SML_063.jpg"
	    }
     ];

     return slides;
} 
